import { url } from "../utils/config";
import Table from "../reusable_components/Table";
import { useState } from "react";
import Button from "../reusable_components/Button";
import { btnOne, title } from "../utils/style";
import FleetInvoicePreview from "./FleetInvoicePreview";
import { toast } from "react-toastify";
import { formatDate } from "../helperFunctions/estimateCalculation"
import formatNumberToUs from "../custom_functions/formatNumberToUs";

function FleetEstimates() {
    const [showForm, setShowForm] = useState(false)
    const [reloadTable, setReloadTable] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const [showPreview, setShowPreview] = useState(false)

    const validateCustomer = (selectedRows) => {
        const customerId = selectedRows[0].fleet_booking.fleet_customer.id;
        return selectedRows.every(estimate => estimate.fleet_booking.fleet_customer.id === customerId);
    }

    const validateTaxRate = (selectedRows) => {
        const taxRate = selectedRows[0].fleet_booking.taxRatePercent;
        return selectedRows.every(estimate => estimate.fleet_booking.taxRatePercent === taxRate);
    }

    const handlePreview = () => {
        const isCustomerValid = validateCustomer(selectedRows);
        const isTaxRateValid = validateTaxRate(selectedRows);

        if (!isCustomerValid) {
            return toast.error("Please select work orders with the same customer.", { autoClose: 3000 });
        } else if (!isTaxRateValid) {
            return toast.error("Please select work orders with the same tax rate.", { autoClose: 3000 });
        } else {
            setShowPreview(true)
        }
    }

    const options = [
        {
            header: "Booking Id",
            key: "fleet_booking",
            render: (data => { return `FAP000${data.fleet_booking.id}` })

        },
        {
            header: 'Customer',
            key: "fleet_booking.fleet_customer.name",
            render: (data) => { return data.fleet_booking.fleet_customer.name },
        },
        {
            header: 'Status',
            key: 'status',
            render: (data) => { return (data.status === "Modified" || data.status === 'Approved') ? "Closed" : data.status },
        },
        {
            header: 'Payment Due Date',
            key: 'dueDate',
            isDateFilter: true,
            placeHolder: 'mm-dd-yyyy',
            render: (data) => { return formatDate(data.dueDate || data.estimatedDate) }
        },
        {
            header: 'Parts Cost',
            key: 'materialCost',
            render: (data) => { return data.materialCost === 0 ? "$0.00" : `$${formatNumberToUs(data.materialCost)}` },
        },
        {
            header: 'Subtotal',
            key: 'totalCost',
            render: (data) => { return data.totalCost === 0 ? "$0.00" : `$${formatNumberToUs(data.totalCost)}` },
        },
        {
            header: "Tax Rate",
            key: "fleet_booking.taxRatePercent",
            render: (data => { return `${data.fleet_booking.taxRatePercent || 0}%` })

        },
        {
            header: 'Tax',
            key: 'tax',
            render: (data) => { return data.tax === 0 ? "$0.00" : `$${formatNumberToUs(data.tax)}` },
        },
        {
            header: 'Total',
            key: 'totalCostFinal',
            render: (data) => { return data.totalCostFinal === 0 ? "$0.00" : `$${formatNumberToUs(data.totalCostFinal)}` },
        }
    ]

    const excludeFilter = ["Parts Cost", "Due Date", "Subtotal", "Tax", "Total"]

    const multiSelectedKeyPair = [{ key: "status", value: "Invoiced" }]

    return (
        <div className="overflow-y-auto">
            {showPreview &&
                <FleetInvoicePreview
                    setShowPreview={setShowPreview}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows}
                    setReloadTable={setReloadTable}
                    reloadTable={reloadTable}
                />
            }
            <div className="flex justify-between items-center mb-4">
                <div className={title}>Fleet Estimates</div>
                <div>
                    <Button className={btnOne} name={'Generate Invoice'} clickHandler={() => handlePreview()} />
                </div>
            </div>
            <Table
                className="max-h-[80vh] overflow-y-auto"
                options={options}
                url={url + '/invoicing_fleet_work_estimates'}
                pagination
                clickHandler={() => setShowForm(!showForm)}
                btnTitle='Manager'
                reloadTable={reloadTable}
                noButton={true}
                isMultiSelect={true}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                excludeFilter={excludeFilter}
                multiSelectedKeyPair={multiSelectedKeyPair}
            />
        </div>
    )
}

export default FleetEstimates;